export class Alergia {
    codigo: string;
    medicamento: string;
    idAlergiaUsuario: string;
    descripcion: string;
    cpfNombreComponente: string;
    sospecha: string;
    fecha: Date;
    dniMedico: string;
    cpfIdComponente: string;
    cip: string;
    numeroExpediente: string;
    visita: string;
    idModulo: string;
}



// WEBPACK FOOTER //
// ./src/models/alergia.ts